module.exports = __webpack_public_path__ + "img/sprite.6f3dcabe.svg";